module.exports = __webpack_public_path__ + "img/kefu.png?v=1";